<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modal__backdrop" @click="closeModal()" />

      <div class="modal__dialog" :style="containerStyle">
        <div class="modal__header" :style="headerStyleAttr">
          <h3>Please select your nearest branch</h3>
          <button type="button" title="Close (Esc)" class="modal__close" @click="closeModal()">×</button>
        </div>

        <div class="modal__body" :style="bodyStyleAttr" ref="menuItem4">
          <div class="view-container text-center">
            <form name="BranchSelectContainer">
                <!-- @foreach (var branch in Model)
                { -->
                <div v-for="branch in branches" :key="branch.id" name="BranchContainer" :data-id="branch.id">
                    <iframe frameborder="0" style="border:0" :src="branch.mapURL" allowfullscreen></iframe>
                    <h3>{{branch.name}}</h3>
                    <div class="form-group branch-contact">
                        <label>Contact no:</label>
                        <label class="contact">{{branch.contactNo}}</label>
                    </div>
                    <div class="form-group branch-email">
                        <label>Email address:</label>
                        <label class="email">{{branch.emailAddress}}</label>
                    </div>
                    <div class="form-group branch-select">
                        <button class="btn btn-primary">Select</button>
                    </div>
                </div>
                <!-- } -->
            </form>
          </div>
        </div>

        <div class="modal__footer" style="padding:0px;">
          <slot name="footer" />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "BranchModal",
  props: {
      containerStyle: String,
      headerStyle: String,
      bodyStyle: String,
      footerStyle: String,
  },
  data() {
    return {
      show: false,
      containerStyleAttr: !this.isStringNullOrEmpty(this.containerStyle) ? this.containerStyle : "",
      headerStyleAttr: !this.isStringNullOrEmpty(this.headerStyle) ? this.headerStyle : "",
      bodyStyleAttr: !this.isStringNullOrEmpty(this.bodyStyle) ? this.bodyStyle : "",
      footerStyleAttr: !this.isStringNullOrEmpty(this.footerStyle) ? this.footerStyle : "",

      branches: []
    };
  },
  methods: {
    closeModal() {
      this.show = false;
      document.querySelector("html").classList.remove("overflow-hidden");
    },
    openModal() {
      this.show = true;
      document.querySelector("html").classList.add("overflow-hidden");
    },
    populate(data) {
      this.branches = data;
    }
  },
  mounted() {
    
  }
};
</script>
<style scoped>
.modal {
  display: block;
  overflow-x: hidden;
  overflow-y: auto;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9;
}
.modal__backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 1;
}
.modal__dialog {
  position: relative;
  width: 100%;
  max-width: 1200px;
  background-color: #ffffff;
  border-radius: 5px;
  margin: 50px auto auto auto;
  display: flex;
  flex-direction: column;
  z-index: 2;
  max-height: 90vh;
}
.modal__close {
  width: 44px;
  height: 44px;
  line-height: 44px;
  position: absolute;
  right: 0;
  top: 0;
  text-decoration: none;
  text-align: center;
  opacity: 0.65;
  background: transparent;
  border: none;
  font-family: "Open Sans", Arial, sans-serif;
  font-weight: 600;
  font-size: 22px;
}
.modal__header {
  height: auto;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 20px 20px 10px;
  background-size: contain;
  background-color: white !important;
  background-repeat: no-repeat;
}
.modal__body {
  padding: 10px 10px 20px 20px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.modal__footer {
  padding: 10px 20px 20px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

@media screen and (max-width: 992px) {
  .modal__dialog {
    width: 90vw;
  }
}

@media screen and (max-width: 500px){
  .modal__dialog {
    height: auto !important;
    position: absolute; 
    top: 47%; 
    left: 50%; 
    transform: translate(-50%, -50%); 
  }
}

</style>